import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import './App.css';
import Homepage from './containers/Homepage';
import Impressum from './containers/Impressum';
import Datenschutz from './containers/Datenschutz';
import News from './containers/News';
import Rechner from './containers/Rechner';
import RechnerDetail from './containers/RechnerDetail';
import ScrollToTop from './components/ScrollToTop';

function App() {
  useEffect(() => {
    const elements = document.querySelectorAll('.reveal');
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);
  return (
    <div className="app">
      <ScrollToTop behavior="auto" />
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/news" element={<News />} />
        <Route path="/rechner" element={<Rechner />} />
        <Route path="/rechner/:id" element={<RechnerDetail />} />
        <Route path="/impressum" element={<Impressum />} />
        <Route path="/datenschutz" element={<Datenschutz />} />
      </Routes>
    </div>
  );
}

export default App;
